import { DownOutlined, ExportOutlined, LoadingOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Button, Col, Divider, Dropdown, Row, Space, Spin, Table, Tag } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import ContainerComponent from '../../../helpers/components/container.component';
import PageHeaderComponent from '../../../helpers/components/page_header.component';
import customPassService from '../../../services/config/custom_pass.service';
import parkService from '../../../services/config/park.service';
import globalHelper from '../../../helpers/functions/global.helper';

const PeriodPassDetailLayout = ({ period_pass_id, }) => {
    const [state, setState] = useState({
        loading : false,
        action_loading : false,
        period_pass : null,
        base_url : null,
    })

    const exportPassList = () => {
        setState(state => ({...state, action_loading : true, }));
        const { period_pass, base_url } = state;

        const data = period_pass?.passes?.map(pass => ({
            'Pass Name' : pass?.name,
            'Pass Code' : pass?.pass_code,
            'URL'       : `${base_url}ticket/pass/${pass?.pass_code}`,
        }));

        globalHelper?.exportToExcel({
            data,
            additional_data : [
                [`Prefix: ${period_pass?.prefix}`],
                [`From Date: ${period_pass?.start_date ? moment(period_pass?.start_date)?.format("YYYY-MM-DD") : '-'}`],
                [`End Date: ${period_pass?.end_date ? moment(period_pass?.end_date)?.format("YYYY-MM-DD") : '-'}`],
                [`Total: ${period_pass?.passes?.length} passes`],
            ],
            name : `${period_pass?.prefix}_passes`,
        });

        setState(state => ({...state, action_loading : false, }));
    }

    const fetchPeriodPass = async () => {
        setState(state => ({...state, loading : true, }));
        const [periodPassResponse, parkResponse] = await Promise.all([
            customPassService?.getPeriodPass(period_pass_id),
            parkService?.getParkByAuth(),
        ]);
        const { period_pass } = periodPassResponse;
        const base_url = parkResponse?.parks?.find(p => p?.park_id === 1)?.base_url;
        setState(state => ({...state, loading : false, period_pass, base_url, }));
    }

    useEffect(() => {
        fetchPeriodPass();
    }, [])

    const { period_pass } = state;

    return (
        <>
            <Spin spinning={state?.loading} indicator={<LoadingOutlined />}>
                <div>
                    <div className='title-header mobile-padding-24' style={{textAlign:'start'}}>
                        <ContainerComponent span={20}>
                            <div style={{display:'flex', alignItems:'center',}}>
                                <div>
                                    <div>
                                        <PageHeaderComponent title={'Period Pass Detail'} />
                                    </div>
                                    <div>
                                        <span style={{fontSize:18, color:'#595959'}}>{period_pass?.prefix}</span>
                                    </div>
                                </div>
                                <div style={{marginLeft:'auto'}}>
                                    <Dropdown
                                    placement='bottomRight'
                                    overlayStyle={{borderRadius:12, minWidth:200,}}
                                    trigger={['click']}
                                    menu={{
                                        items : [{
                                            key : 'export',
                                            icon : <ExportOutlined />,
                                            label : (
                                                <div>
                                                    <Space>
                                                        <span>Export Pass List</span>
                                                    </Space>
                                                </div>
                                            ),
                                            disabled : !period_pass?.passes?.length,
                                            onClick : () => exportPassList(),
                                        }]
                                    }}
                                    >
                                        <Button loading={state?.action_loading} type='primary' icon={<DownOutlined />}>
                                            Action
                                        </Button>
                                    </Dropdown>
                                </div>
                            </div>
                        </ContainerComponent>
                    </div>

                    <div className='mobile-padding-24' style={{marginTop:24,}}>
                        <ContainerComponent span={20}>
                            {/* Pass Information */}
                            <div style={{background:'var(--secondary-bg-color)', borderRadius:8, padding:24,}}>
                                <div>
                                    <PageHeaderComponent title={<span style={{fontSize:16,}}>Pass Information</span>} textAlign={'start'} />
                                </div>
                                <Divider />
                                <Row gutter={[20, 16]}>
                                    <Col xs={24} sm={12}>
                                        <div style={{textAlign:'start',}}>
                                            <div style={{color:'var(--secondary-text-color)', fontSize:12, marginBottom:4,}}>Prefix</div>
                                            <div><span>{period_pass?.prefix ?? '-'}</span></div>
                                        </div>
                                    </Col>
                                    <Col xs={24} sm={12}>
                                        <div style={{textAlign:'start',}}>
                                            <div style={{color:'var(--secondary-text-color)', fontSize:12, marginBottom:4,}}>Quantity</div>
                                            <div><span>{period_pass?.quantity ?? '-'}</span></div>
                                        </div>
                                    </Col>
                                    <Col xs={24} sm={12}>
                                        <div style={{textAlign:'start',}}>
                                            <div style={{color:'var(--secondary-text-color)', fontSize:12, marginBottom:4,}}>From Date</div>
                                            <div><span>{period_pass?.start_date ? moment(period_pass?.start_date)?.format("YYYY-MM-DD") : '-'}</span></div>
                                        </div>
                                    </Col>
                                    <Col xs={24} sm={12}>
                                        <div style={{textAlign:'start',}}>
                                            <div style={{color:'var(--secondary-text-color)', fontSize:12, marginBottom:4,}}>End Date</div>
                                            <div><span>{period_pass?.end_date ? moment(period_pass?.end_date)?.format("YYYY-MM-DD") : '-'}</span></div>
                                        </div>
                                    </Col>
                                    <Col xs={24} sm={12}>
                                        <div style={{textAlign:'start',}}>
                                            <div style={{color:'var(--secondary-text-color)', fontSize:12, marginBottom:4,}}>Parks</div>
                                            <div>
                                                <Space wrap>
                                                {
                                                    period_pass?.parks?.length > 0 ? period_pass?.parks?.map((park, index) => {
                                                        const { name } = park ?? {};
                                                        return (
                                                            <Tag key={index} style={{background:'var(--secondary-button-color)', color:'var(--secondary-text-color)', border:'none',}}>
                                                                {name}
                                                            </Tag>
                                                        )
                                                    }) : <span>-</span>
                                                }
                                                </Space>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xs={24} sm={12}>
                                        <div style={{textAlign:'start',}}>
                                            <div style={{color:'var(--secondary-text-color)', fontSize:12, marginBottom:4,}}>Created Date</div>
                                            <div><span>{period_pass?.created_at ? moment(period_pass?.created_at)?.format("YYYY-MM-DD HH:mm:ss") : '-'}</span></div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>

                            {/* Passes Listing */}
                            <div style={{marginTop:24,}}>
                                <div style={{marginBottom:12,}}>
                                    <PageHeaderComponent title={<span style={{fontSize:16,}}>Passes</span>} textAlign={'start'} />
                                </div>
                                <Table
                                dataSource={period_pass?.passes}
                                scroll={{x : 400,}}
                                pagination={{showSizeChanger: false,}}
                                className='hub-table bordered'
                                rowKey='pass_id'
                                columns={[{
                                    title : 'Pass',
                                    dataIndex : 'name',
                                    key : 'name',
                                    render : (name, row) => {
                                        const generated_color = name ? globalHelper?.generateFixedColorFromString(name) : 'var(--secondary-text-color)';
                                        const { pass_code, url_image } = row;
                                        return (
                                            <Space>
                                                <Avatar src={url_image} style={{backgroundColor: generated_color}} icon={<UserOutlined />} />
                                                <div>
                                                    <div><span>{name}</span></div>
                                                    <div><span style={{fontSize:12, color:'var(--secondary-text-color)'}}>{pass_code}</span></div>
                                                </div>
                                            </Space>
                                        )
                                    }
                                },{
                                    title : 'Status',
                                    dataIndex : 'is_active',
                                    key : 'is_active',
                                    render : (is_active) => {
                                        return (
                                            <Tag color={is_active ? 'green' : 'orange'} style={{border:'none',}}>
                                                {is_active ? 'Active' : 'Inactive'}
                                            </Tag>
                                        )
                                    }
                                },]}
                                />
                            </div>
                        </ContainerComponent>
                    </div>
                </div>
            </Spin>
        </>
    );
}

export default PeriodPassDetailLayout;
